{
  "markread": "marcar como leído",
  "filter": "filtro",
  "newest": "nuevos",
  "unread": "no leídos",
  "starred": "preferidos",
  "online_count": "Elementos disponibles en el servidor",
  "offline_count": "Elementos disponibles localmente",
  "tags": "Etiquetas",
  "alltags": "todas las etiquetas",
  "timestamp": "{0,date} {0,time}",
  "hours": "hace {0,plural,one {1 hora},other {# horas}}",
  "minutes": "hace {0,plural,one {1 minuto},other {# minutos}}",
  "seconds": "hace {0,plural,one {1 segundo},other {# segundos}}",
  "days": "{0,plural,zero {hoy},one {ayer},other {hace # días}}",
  "star": "preferido",
  "unstar": "ya no lo prefiero",
  "mark": "marcar como leído",
  "unmark": "marcar como no leído",
  "load_img": "cargar Imágenes",
  "open_window": "abrir",
  "next": "siguiente",
  "searchbutton": "buscar",
  "searchremove": "ocultar búsqueda",
  "refreshbutton": "actualizar fuentes",
  "settingsbutton": "configuración",
  "logoutbutton": "cerrar sesión",
  "loginbutton": "iniciar sesión",
  "sources": "Fuentes",
  "source_add": "agregar fuente",
  "source_opml": "o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)",
  "source_export": "exportar fuentes",
  "source_edit": "editar",
  "source_filter": "Filtrar",
  "source_delete": "borrar",
  "source_warn": "realmente desea borrar esta fuente?",
  "source_new": "nueva fuente sin guardar",
  "source_title": "Titulo",
  "source_autotitle_hint": "Dejar en blanco para obtener título",
  "source_tags": "Etiquetas",
  "source_pwd_placeholder": "no ha cambiado",
  "source_comma": "separado por comas",
  "source_select": "por favor seleccione una fuente",
  "source_type": "Tipo",
  "source_save": "Guardar",
  "source_cancel": "cancelar",
  "source_saved": "Guardado",
  "source_last_post": "Última entrada vista",
  "source_refresh": "Actualizar esta fuente",
  "no_entries": "No se encontraron entradas",
  "more": "más",
  "login": "iniciar sesión",
  "login_username": "usuario",
  "login_password": "contraseña",
  "login_invalid_credentials": "usuario/contraseña incorrectos",
  "login_offline": "Almacenaje fuera de línea",
  "no_title": "sin título",
  "error": "ha ocurrido un error",
  "streamerror": "Ningún elemento cargado, ¿recargar?",
  "reload_list": "Recargar lista",
  "sources_refreshed": "Las fuentes han sido refrescadas",
  "app_update": "selfoss ha sido actualizado, recargue",
  "app_reload": "Recargar",
  "error_session_expired": "La sesión ha expirado",
  "error_add_source": "Error añadiendo fuente:",
  "error_delete_source": "Error borrando fuente:",
  "error_load_tags": "Error cargando etiquetas:",
  "error_unknown_tag": "Etiqueta desconocida:",
  "error_unknown_source": "Id de fuente desconocido:",
  "error_mark_items": "No se pudo marcar todos los elementos visibles:",
  "error_mark_item": "No se pudo marcar/desmarcar elemento:",
  "error_star_item": "No se pudo preferir/despreferir elemento:",
  "error_logout": "No se pudo registrar:",
  "error_loading": "Error cargando:",
  "error_loading_stats": "No se pudo cargar estadísticas de navegación:",
  "error_saving_color": "No se pudo cargar nuevo color:",
  "error_refreshing_source": "No se pudo refrescar fuentes:",
  "error_sync": "No se pudo sincronizar los últimos cambios del servidor:",
  "error_offline_storage": "Error de almacenaje fuera de línea: {0}. Recargar puede ayudar. Desactivando uso fuera de línea por ahora.",
  "error_invalid_subsection": "Subsección inválida:",
  "search_label": "Buscar término",
  "article_actions": "Acciones",
  "error_configuration": "Imposible cargar configuración.",
  "info_url_copied": "URL copiada al portapapeles.",
  "share_native_label": "Compartir",
  "share_diaspora_label": "Compartir en Diaspora",
  "share_twitter_label": "Compartir en Twitter",
  "share_facebook_label": "Compartir en Facebook",
  "share_pocket_label": "Guardar en Pocket",
  "share_wallabag_label": "Guardar en Wallabag",
  "share_wordpress_label": "Compartir en WordPress",
  "share_mail_label": "Compartir por e-mail",
  "share_copy_label": "Copiar enlace al portapapeles",
  "error_share_native_abort": "Imposible compartir ítem-no hay objetivos que compartir, o has cancelado.",
  "error_share_native": "Imposible compartir ítem.",
  "close_entry": "Cerrar",
  "error_unwritable_logs": "Imposible escribir logs.",
  "error_check_system_logs": "Un error ha ocurido, por favor comprueba tus logs de sistema.",
  "error_check_log_file": "Un error ha ocurrido, por favor comprueba el fichero de log “{0}”.",
  "offline_navigation_unavailable": "Cambiar etiquetas y fuentes no está disponible en el modo fuera de línea.",
  "error_offline_storage_not_available": "Almacenaje fuera de línea no está disponible. Asegúrese que su navegador {0}soporta IndexedDB API{1} y, si está utilizando un navegador basado en Google Chrome, que no está usando selfoss en modo incógnito.",
  "error_edit_source": "No se pudo guardar los cambios en las fuentes:",
  "experimental": "Experimental",
  "article_reading_time": "{0} min lectura",
  "sources_loading": "Cargando fuentes…",
  "source_warn_cancel_dirty": "¿Descartar los cambios no guardados?",
  "error_unauthorized": "Por favor, {link_begin}firme{link_end} para continuar.",
  "no_sources": "No hay fuentes configuradas.",
  "source_menu": "Más acciones",
  "source_browse": "Navegar",
  "source_deleting": "Borrando fuente…",
  "source_params_loading": "Cargando parámetros…",
  "login_in_progress": "Intentando iniciar sesión…",
  "source_saving": "Guardando cambios en la fuente…",
  "source_go_to_settings": "Abrir en los ajustes",
  "tag_change_color_button_title": "Cambiar el color",
  "entries_loading": "Cargando las entradas…",
  "login_error_generic": "No se ha podido iniciar la sesión: {errorMessage}",
  "sources_leaving_unsaved_prompt": "¿Dejar la configuración con los cambios sin guardar?",
  "share_mastodon_label": "Compartir en Mastodon"
}
